import _ from 'lodash';
import React, {FunctionComponent, useState} from 'react';
import {IconButton, Modal} from '@material-ui/core';
import {CloseIcon, EditIcon} from '@treez-ui/core/icons';
import {Title, TitleSize} from '@treez-ui/core/layout/Title';
import {Button, ButtonClass} from '@treez-ui/core/buttons';
import {ProductInCatalog} from '@treez/commons/sharedTypings/product';
import {useDispatch} from 'react-redux';
import ProductCard from '~/modules/widgets/products/ProductCard';
import StoreSelector from '~/modules/widgets/modals/StoreSelector';
import {addProductsToCatalogs} from '~/utils/ProductAPI';
import {
    confirmProductsAdded,
    informUserOfErrorAddingProducts,
} from '~/redux/actionCreators/UserFeedbackCreators';
import {
    useProductFormContext,
    useProductFormStateDispatch,
} from '~/contexts/ProductForm/productFormContext';
import {
    closeProductFormAndInspector,
    openProductFormOnly,
} from '~/contexts/ProductForm/productFormActions';

const OrgProductModal: FunctionComponent = () => {
    const [storeSelectorOpen, setStoreSelectorOpen] = useState<boolean>(false);

    const {productToInspect, isInspectorOpen} = useProductFormContext();
    const productFormDispatch = useProductFormStateDispatch();

    const productId = _.get(productToInspect, 'id');

    const dispatch = useDispatch();

    const addProducts = async (selectedCatalogs: number[], productsToAdd: ProductInCatalog[]) => {
        try {
            const productIds = _.map(productsToAdd, (product) => {
                return product.id;
            });

            await addProductsToCatalogs(selectedCatalogs, productIds);

            dispatch(confirmProductsAdded(productsToAdd.length, selectedCatalogs.length));
        } catch (error) {
            console.error(error);
            dispatch(
                informUserOfErrorAddingProducts(error.message as string, productsToAdd.length)
            );
        }
    };

    const onRequestToEditProduct = () => {
        if (productToInspect) {
            productFormDispatch(openProductFormOnly(productToInspect));
        }
    };

    return (
        <Modal
            open={isInspectorOpen}
            onClose={() => productFormDispatch(closeProductFormAndInspector())}
            className="product-details-modal"
        >
            <div className="organization-product-details-container modal-body-large">
                <div className="product-details-header">
                    <div className="left-options">
                        <Title text="Product Details" size={TitleSize.MEDIUM} />
                    </div>
                    <IconButton onClick={() => productFormDispatch(closeProductFormAndInspector())}>
                        <CloseIcon color="black" />
                    </IconButton>
                </div>
                {productToInspect && (
                    <ProductCard
                        product={productToInspect}
                        actions={[
                            <div className="button-container-large" key="add-to-stores-button">
                                <Button
                                    buttonClass={ButtonClass.PREFERRED}
                                    onClick={() => setStoreSelectorOpen(true)}
                                    text="Add to Stores"
                                />
                            </div>,
                            <div className="button-container-large" key="edit-product-button">
                                <Button
                                    buttonClass={ButtonClass.BASIC}
                                    icon={<EditIcon color="white" />}
                                    onClick={onRequestToEditProduct}
                                    text="Edit Product"
                                />
                            </div>,
                        ]}
                    />
                )}
                {productId && (
                    <StoreSelector
                        addProduct={addProducts}
                        closeModal={() => setStoreSelectorOpen(false)}
                        open={storeSelectorOpen}
                        productId={productId}
                        key="product-modal-store-selector"
                    />
                )}
            </div>
        </Modal>
    );
};

export default OrgProductModal;
